import React from 'react';

const LogoSpinner = () => {
  return (
    <div className="w-max relative">
      <div className="logo-preloader-spinner">

      </div>
      <img
        src="/logo-icon.svg"
        alt="Logo Icon"
        style={{
          height: '32px',
          width: '32px',
          position: 'relative',
          top: '-40px',
          left: '50%',
          transform: 'translate(-50%,-50%)'
        }}
      />

    </div>
  );
};

export default LogoSpinner;
